export default __webpack_public_path__ + "static/media/DDD-Chairside-solutions.277746be.jpg";